import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SITE = "https://sendme.co.in";
const DEFAULT_IMAGE = `${SITE}/logo512.png`;

/**
 * PageMeta — per-route <title>, description, canonical, OpenGraph and Twitter card.
 * Drop it at the top of any page component. Values passed here override the defaults
 * in index.html so Google (and social scrapers) see route-specific metadata.
 */
export default function PageMeta({
  title,
  description,
  image = DEFAULT_IMAGE,
  path,           // e.g. "/blog/xyz" — omit to auto-detect from useLocation()
  type = "website",
  publishedTime,  // ISO date string for articles
  modifiedTime,
  author,
  noindex = false,
  keywords,
}) {
  const location = useLocation();
  const canonical = `${SITE}${path || location.pathname}`;
  const fullTitle = title ? `${title} · SendMe` : "SendMe — Share files with a 6-digit code";

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex,follow" />}

      {/* Open Graph */}
      <meta property="og:site_name" content="SendMe" />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="en_US" />
      {publishedTime && <meta property="article:published_time" content={publishedTime} />}
      {modifiedTime && <meta property="article:modified_time" content={modifiedTime} />}
      {author && <meta property="article:author" content={author} />}

      {/* Twitter card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
